import { useEffect, useRef, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { usd, COLOR } from "./util";

export const Buscador = ({ onElegir }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [atajos, setAtajos] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [sel, setSel] = useState(-1);
  const caja = useRef(null);

  useEffect(() => { api.get("/resumen/buscar", { params: { q: "" } }).then((r) => setAtajos(r.data.items || [])).catch(() => setAtajos([])); }, []);
  const [elegido, setElegido] = useState("");
  useEffect(() => {
    if (!q.trim() || q === elegido) { setItems([]); setAbierto(false); return; }
    const t = setTimeout(() => {
      api.get("/resumen/buscar", { params: { q } }).then((r) => { setItems(r.data.items || []); setAbierto(true); setSel(-1); }).catch(() => setItems([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const fuera = (e) => { if (caja.current && !caja.current.contains(e.target)) setAbierto(false); };
    document.addEventListener("mousedown", fuera);
    return () => document.removeEventListener("mousedown", fuera);
  }, []);

  const elegir = (c) => { setAbierto(false); setItems([]); setElegido(c.cliente); setQ(c.cliente); caja.current?.querySelector("input")?.blur(); onElegir(c); };
  const teclas = (e) => {
    if (!abierto || !items.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => Math.min(s + 1, items.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setSel((s) => Math.max(s - 1, 0)); }
    else if (e.key === "Enter" && sel >= 0) { e.preventDefault(); elegir(items[sel]); }
    else if (e.key === "Escape") setAbierto(false);
  };

  return (
    <div>
      <div className="rs-buscador" ref={caja}>
        <Search className="rs-lupa h-6 w-6" />
        <input data-testid="resumen-buscador" className="rs-buscador-input" placeholder="Nombre del cliente…" value={q} role="combobox" aria-expanded={abierto}
          onChange={(e) => setQ(e.target.value)} onKeyDown={teclas} onFocus={() => items.length && setAbierto(true)} />
        {abierto && (
          <div className="rs-lista" role="listbox" data-testid="resumen-lista">
            {items.length === 0 && <div className="rs-vacio" style={{ padding: "10px 14px" }}>Sin coincidencias</div>}
            {items.map((c, i) => (
              <button key={c.cliente} role="option" aria-selected={i === sel} className="rs-op" data-testid={`resumen-op-${i}`} onMouseEnter={() => setSel(i)} onClick={() => elegir(c)}>
                <span className="rs-punto" style={{ background: COLOR[c.estado?.estado] || COLOR.al_dia }} />
                <span className="min-w-0"><span className="n block truncate">{c.cliente}{c.no_computa && <span className="rs-est" style={{ background: "#4A3628", color: "#F3F7F2", marginLeft: 8 }}>No computa</span>}</span><span className="m">{c.vendedor} · {c.zona || "—"} · {c.estado?.texto}</span></span>
                <span className="s">{usd(c.saldo)}</span>
              </button>
            ))}
          </div>
        )}
      </div>
      {!q.trim() && atajos.length > 0 && (
        <div className="rs-atajos" data-testid="resumen-atajos">
          {atajos.map((c) => (
            <button key={c.cliente} className="rs-atajo" onClick={() => elegir(c)} data-testid="resumen-atajo">
              <span className="rs-punto" style={{ background: COLOR.vencido }} /><span className="truncate max-w-[200px]">{c.cliente}</span><span className="s">{usd(c.vencido)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
